<div class="container-fluid p-0">
  <!-- login page start-->
  <div class="authentication-main">
    <div class="row">
      <div class="col-md-12">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="text-center"><img src="assets/images/enplace_logo.png"
                alt></div>
            <div class="card mt-4">
              <div class="card-body">
                <div class="text-center">
                  <h4>LOGIN</h4>
                  <h6>Enter your Username and Password </h6>
                </div>
                <form [formGroup]="loginForm" class="theme-form">
                  <div class="form-group">
                    <label class="col-form-label pt-0">Email</label>
                    <input class="form-control" type="text"
                      formControlName="email">
                    <span
                      *ngIf="checkErrors && getFormControl('email')!.errors?.['required']"
                      class="text-danger">Email is
                      required.</span>
                    <span
                      *ngIf="getFormControl('email')!.value != '' && !getFormControl('email')!.value?.match(validEmailRegex)"
                      class="block text-danger">A valid email is
                      required.</span>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <input class="form-control" type="password"
                      formControlName="password">
                    <span
                      *ngIf="checkErrors && getFormControl('password')!.errors?.['required']"
                      class="text-danger">Password is
                      required.</span>
                  </div>
                  <div class="checkbox p-0">
                    <div
                      class="d-flex justify-content-between align-items-center">
                      <div>
                        <input id="checkbox1" type="checkbox"
                          formControlName="rememberMe">
                        <label for="checkbox1">Remember
                          me</label>
                      </div>
                      <div>
                        <a href="javascript:void(0)"
                          (click)="forgotPassword()">Forgot Password?</a>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row mt-3 mb-0">
                    <button class="btn btn-primary btn-block"
                      (click)="signIn()">Login</button>
                  </div>
                  <div class="form-group row mt-3 mb-0">
                    <button
                      class="btn btn-secondary btn-block"
                      (click)="register()">Register</button>
                  </div>
                  <div class="login-divider"></div>
                  <div class="social mt-3">
                    <div class="form-group btn-showcase d-flex">
                      <button class="btn social-btn btn-fb d-inline-block"> <i
                          class="fa fa-facebook"></i></button>
                      <button
                        class="btn social-btn btn-twitter d-inline-block"><i
                          class="fa fa-google"></i></button>
                      <button
                        class="btn social-btn btn-google d-inline-block"><i
                          class="fa fa-twitter"></i></button>
                      <button
                        class="btn social-btn btn-github d-inline-block"><i
                          class="fa fa-github"></i></button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- login page end-->
</div>